import React from 'react';
import './carousel.css';

function Slide({ slide, offset, altDescription, isMobile }) {
    const active = offset === 0 ? true : null;
    const ref = React.useRef(null);
    return (
        <div
            ref={ref}
            className="slide"
            data-active={active}
            //style={{}}
        >
            <img 
                key={`img${slide}`} 
                src={slide} 
                loading='lazy'
                alt={`realisation ${altDescription}`} 
                style={{height: '80vh', width: isMobile ? '90vw' : 'calc(63vw)', borderRadius: '0 30px 30px 0', objectFit: 'cover', marginTop: '.5rem'}}
            />
        </div>
    );
}

function Carousel(props) {
    const { slides, altDescription, isMobile } = props;

    const [slideIndex, dispatch] = React.useReducer((state, event) => {
        if (event.type === "NEXT") return (state + 1) % slides.length;
        if (event.type === "PREV") return state === 0 ? slides.length - 1 : state - 1;
        return state;
    }, 0);

    React.useEffect(() => {
        const toPreload = [
            (slideIndex + 2) % slides.length,
            (slideIndex - 2 + slides.length) % slides.length,
        ];
        toPreload.forEach(i => {
            const img = new Image();
            img.src = slides[i];
        });
    }, [slideIndex]);

    const visibleIndexes = [
        (slideIndex - 1 + slides.length) % slides.length,
        slideIndex,
        (slideIndex + 1) % slides.length,
    ];

    return (
        <div className="slides">
            <button style={{ cursor: 'pointer', left: '2%', top: '44%' }}
                onClick={() => dispatch({ type: "PREV" })}>
                <span className="hard-shadow">{'<'}</span>
            </button>

            {visibleIndexes.map((realIndex) => {
                const offset = realIndex - slideIndex;
                return (
                    <Slide
                        isMobile={isMobile}
                        slide={slides[realIndex]}
                        offset={offset}
                        key={`slide_${realIndex}`}
                        altDescription={altDescription}
                    />
                );
            })}

            <button style={{ cursor: 'pointer', right: '2%', top: '44%' }}
                onClick={() => dispatch({ type: "NEXT" })}>
                <span className="hard-shadow">{'>'}</span>
            </button>
        </div>
    );
}

export default Carousel;